import { defineComponent as _defineComponent } from 'vue';
import { ref, reactive, computed, onUnmounted, getCurrentInstance } from 'vue';
import { useRouter } from '@blade/common/utils/useVueApi';
import myPopover from '@blade-sxp/file-cluster/pages/create-task/components/popover.vue';
import lineCharts from '@blade-sxp/file-cluster/pages/create-task/components/line-charts/index.vue';
import pictureWall from '@blade-sxp/file-cluster/pages/create-task/components/picture-wall/index.vue';
import { postCaptureImages, postAggregationCount, postAggregationTrend } from '@blade-sxp/file-cluster/api/create-task/index';
import { AlarmWebsocket as Websocket, MessageType } from '@blade/common/utils/websocket';
import { LoginModule } from '@blade/common/store/login';
export default /*#__PURE__*/ _defineComponent({
    __name: 'analysis-page',
    setup(__props) {
        const hotAreaMap = {
            hotAreaA: '/fileCluster/list',
            hotAreaB: '/dataMining/companions',
            hotAreaC: '/dataMining/bigData',
        };
        const imageList = ref([]);
        const order = ref(false);
        let preLoadList = [];
        const layoutPermissions = computed(() => {
            return LoginModule.permissions;
        });
        const hasPermission = computed(() => {
            for (let i = 0; i < layoutPermissions.value.length; i++) {
                const permission = layoutPermissions.value[i];
                if (permission.code === '11') {
                    return permission.enable;
                }
            }
            return false;
        });
        // 接口请求 && 预加载
        function getImageList() {
            if (!preLoadList.length) {
                postCaptureImages().then((data) => {
                    imageList.value = data;
                });
            }
            else {
                imageList.value = preLoadList;
            }
            // 五秒之后请求下一组图片并预加载
            setTimeout(() => {
                postCaptureImages().then((data) => {
                    imagePreload(data);
                });
            }, 5000);
        }
        const aggregationCount = ref(null);
        const lineChartData = reactive({
            documentCount: [],
            trackCount: [],
        });
        function formatNumber(value) {
            if (!value)
                return '0';
            const valueStr = value.toString();
            return valueStr?.replace(/\B(?=(\d{3})+\b)/g, ',');
        }
        const wsUrl = process.env.NODE_ENV === 'development'
            ? process.env.VUE_APP_REALTIME_WS
            : `wss://${window.location.host}/${process.env.VUE_APP_REALTIME_WS}`;
        let upWS = null;
        function initWebsocket() {
            upWS = new Websocket(wsUrl);
            upWS.setOnMessage(websocketOnMessage);
        }
        function websocketOnMessage(e) {
            const msg = JSON.parse(e.data);
            if (msg.messageType !== MessageType.DOCUMENT_COUNT_ALL)
                return;
            const content = JSON.parse(msg.content);
            aggregationCount.value = content;
        }
        function getCount() {
            postAggregationCount().then((data) => {
                aggregationCount.value = data;
            });
        }
        // 接口请求
        getImageList();
        getCount();
        getLineChartData();
        initWebsocket();
        // preload
        function imagePreload(data) {
            preLoadList = data;
            const promises = [];
            preLoadList.forEach((image) => {
                const promise = new Promise((resolve) => {
                    const img = new Image();
                    img.onload = () => {
                        resolve();
                    };
                    // img.onerror = reject;
                    img.src = image.portraitImage ?? '';
                });
                promises.push(promise);
            });
            // Promise.all(promises).then(() => {
            //   // 所有图片都加载完成后更新视图
            //   console.log('===预加载完毕');
            // });
        }
        function getLineChartData() {
            postAggregationTrend('TRACK').then((data) => {
                lineChartData.trackCount = data;
            });
            postAggregationTrend('DOCUMENT').then((data) => {
                lineChartData.documentCount = data;
            });
        }
        const interval = setInterval(() => {
            // 动画淡出开始
            order.value = !order.value;
            setTimeout(() => {
                // 新一组图片进入
                getImageList();
                order.value = !order.value;
            }, 2000);
        }, 12000);
        // 取消定时器
        onUnmounted(() => {
            clearTimeout(interval);
            upWS?.close();
        });
        const router = useRouter();
        const vm = getCurrentInstance().proxy;
        function navigateTo(key) {
            if (key !== 'hotAreaA' && !hasPermission.value) {
                vm?.$message({ message: vm.$t('navigatePermission'), type: 'warning' });
                return;
            }
            router.push(hotAreaMap[key]);
        }
        return { __sfc: true, hotAreaMap, imageList, order, preLoadList, layoutPermissions, hasPermission, getImageList, aggregationCount, lineChartData, formatNumber, wsUrl, upWS, initWebsocket, websocketOnMessage, getCount, imagePreload, getLineChartData, interval, router, vm, navigateTo, myPopover, lineCharts, pictureWall };
    }
});
